import React from 'react';
import { isEmpty } from 'lodash';

import { Modal, Form, Row, Col, Button } from 'react-bootstrap';
import { Field } from 'formik';
import { DropdownList } from 'react-widgets';
import DatePicker from 'react-datepicker';

import ValidatedFormInputField from '../../../../../../../core-components/ValidatedFormInputField';
import Image from '../../../../../../../core-components/Image';

import styles from './AddEditModal.module.scss';

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 61 }, (_, i) => currentYear - 50 + i);

class AddEditModal extends React.Component {
  constructor(props) {
    super(props);
  }

  makeBtnEnable = () => {
    const {
      universityName,
      registrationNumber,
      startDate,
      endDate,
      educationLevel,
      degreeType,
      collegeName
    } = this.props.values;
    return (universityName &&
      registrationNumber &&
      startDate &&
      endDate &&
      educationLevel &&
      degreeType,
    collegeName)
      ? true
      : false;
  };

  render() {
    const { handleSubmit, isSubmitting, values, errors, setFieldValue, touched } = this.props;
    const enableBtn =
      !isSubmitting &&
      isEmpty(errors) &&
      this.makeBtnEnable() &&
      values.startDate <= values.endDate &&
      values.degreeType &&
      values.educationLevel
        ? true
        : false;
    const educationLevel = ['10', '12/Diploma', 'Undergraduate', 'Postgraduate', 'PHD', 'Other'];
    const degreeType = ['Full Time', 'Part Time', 'Distance'];

    const handleChange = (date, fieldname) => {
      const value = values[fieldname];

      if (value && date) {
        const year = new Date(value).getFullYear();
        setFieldValue(fieldname, new Date(year, date.getMonth()));
      } else {
        setFieldValue(fieldname, date);
      }
    };

    const handleYearChange = (e, fieldname) => {
      setFieldValue(
        fieldname,
        new Date(e.target.value, values[fieldname] ? values[fieldname].getMonth() : 0)
      );
    };

    return (
      <Modal
        size='lg'
        show={this.props.show}
        onHide={this.props.onHide}
        dialogClassName='educationModal'
        backdropClassName={'customBGVModalBackdrop'}
      >
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter'>
            <div className={styles.educationModalTitle}>
              <span>{this.props.isEdit ? 'Edit Education' : 'Add Education'}</span>
            </div>
            <div className={styles.educationModalSubTitle}>
              <span>{`Step ${this.props.currentSubStep} of ${this.props.totalStep}`}</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} className='add-edit-education-form'>
          <Modal.Body className={styles.addEditEducationModalBody}>
            <Row>
              <Col sm={12} xs={12} md={6} lg={6}>
                <Form.Label>
                  Course Type <span>*</span>
                </Form.Label>
                <Form.Group className={styles.formGroup}>
                  <DropdownList
                    data={educationLevel}
                    value={values.educationLevel}
                    selectIcon={<Image name='dropdownArrow.svg' />}
                    onChange={(value) => {
                      setFieldValue('educationLevel', value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={12} xs={12} md={6} lg={6}>
                <Form.Label>
                  Attendance Type <span>*</span>
                </Form.Label>
                <Form.Group className={styles.formGroup}>
                  <DropdownList
                    data={degreeType}
                    value={values.degreeType}
                    selectIcon={<Image name='dropdownArrow.svg' />}
                    onChange={(value) => {
                      setFieldValue('degreeType', value);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Form.Label>
                  University/Board <span>*</span>
                </Form.Label>
                <Field type='text' name='universityName' component={ValidatedFormInputField} />
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Form.Label>
                  College/Institution/School <span>*</span>
                </Form.Label>
                <Field type='text' name='collegeName' component={ValidatedFormInputField} />
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={6} lg={6}>
                <Form.Label>
                  Registration Number <span>*</span>
                </Form.Label>
                <Field type='text' name='registrationNumber' component={ValidatedFormInputField} />
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Form.Label>Degree</Form.Label>
                <Field
                  type='text'
                  name='degree'
                  component={ValidatedFormInputField}
                  placeholder='Eg: Bachelor of Technology, Master of Design'
                  disabled={values.educationLevel === '10' || values.educationLevel === '12'}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Form.Label>Specialization</Form.Label>
                <Field
                  type='text'
                  name='areasOfStudy'
                  component={ValidatedFormInputField}
                  placeholder='Eg: Electrical Engineering, Computer Science'
                  disabled={values.educationLevel === '10'}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Label>
                  Dates Attended <span>*</span>
                </Form.Label>
              </Col>
              <Col
                sm={12}
                xs={12}
                md={6}
                lg={6}
                className={
                  (!!errors.startDate && touched.startDate) ||
                  (values.startDate && values.endDate && values.startDate > values.endDate)
                    ? 'empDatePicker'
                    : ''
                }
              >
                <Form.Group className={styles.formGroupDate}>
                  <DatePicker
                    placeholderText='From'
                    className={styles.datePickerStyle}
                    dateFormat='MM/yyyy'
                    isClearable
                    minViewMode='months'
                    showMonthYearPicker
                    selected={values.startDate}
                    renderCustomHeader={() => (
                      <div className={styles.datePickerHeaderStyle}>
                        <select
                          value={
                            values.startDate
                              ? values.startDate.getFullYear()
                              : new Date().getFullYear()
                          }
                          onChange={(e) => handleYearChange(e, 'startDate')}
                        >
                          {YEARS.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    onChange={(date) => handleChange(date, 'startDate')}
                  />

                  {values.startDate && values.endDate && values.startDate > values.endDate ? (
                    <div className={styles.errorMsg}>{'Please enter the correct date range'}</div>
                  ) : null}
                  {!!errors.startDate && touched.startDate && (
                    <div className={styles.errorMsg}>{errors.startDate}</div>
                  )}
                </Form.Group>
              </Col>
              <Col
                sm={12}
                xs={12}
                md={6}
                lg={6}
                className={
                  (!!errors.endDate && touched.endDate) ||
                  (values.startDate && values.endDate && values.startDate > values.endDate)
                    ? 'empDatePicker'
                    : ''
                }
              >
                <Form.Group className={styles.formGroupDate}>
                  <DatePicker
                    key={'endDate'}
                    placeholderText='To (or expected graduation)'
                    className={styles.datePickerStyle}
                    dateFormat='MM/yyyy'
                    isClearable
                    minViewMode='months'
                    showMonthYearPicker
                    selected={values.endDate}
                    renderCustomHeader={() => (
                      <div className={styles.datePickerHeaderStyle}>
                        <select
                          value={
                            values.endDate ? values.endDate.getFullYear() : new Date().getFullYear()
                          }
                          onChange={(e) => handleYearChange(e, 'endDate')}
                        >
                          {YEARS.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    onChange={(date) => handleChange(date, 'endDate')}
                  />

                  {values.startDate && values.endDate && values.startDate > values.endDate ? (
                    <div className={styles.errorMsg}>{'Please enter the correct date range'}</div>
                  ) : null}
                  {!!errors.endDate && touched.endDate && (
                    <div className={styles.errorMsg}>{errors.endDate}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className={styles.educationSubmitBtn}>
            <div>
              <Button
                className={styles.cancelBtn}
                onClick={(e) => {
                  this.props.onHide();
                }}
              >
                Cancel
              </Button>
              <Button
                className={!enableBtn ? styles.disableBtn : styles.activeBtn}
                disabled={!enableBtn}
                type='submit'
              >
                Next
              </Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default AddEditModal;
